<app-headline>
  <h1 app-headline-title
  color="primary">Device errors</h1>
</app-headline>

<ngrx-busy>
  <mat-card>
    <mat-card-header>
      <mat-card-title-group>
        <!-- <mat-card-title>{{ stat.revision }}</mat-card-title>
        <mat-card-subtitle>Total operated devices in the revision: {{ stat.total }}</mat-card-subtitle> -->
      </mat-card-title-group>
    </mat-card-header>
    <mat-card-content>
      @if (isDataLoaded) {
        <highcharts-chart
          [Highcharts]="linesHighcharts"
          [options]="linesChartOptions"
        class="chart"></highcharts-chart>
      }
    </mat-card-content>
  </mat-card>
</ngrx-busy>
